export default __webpack_public_path__ + "static/media/img_post4.e699f687.png";